export const ctaButtonClicked = (position, href, ctaText) => ({
  type: 'CTA Button Clicked',
  data: { cta_position: position, url: href, cta_text: ctaText },
});
